class MoneyService {
    static explodeMoney(amount) {
        let sign = amount >= 0 ? "" : "-";
        let amtNum = Math.abs(amount);
        let amt = amtNum
            .toFixed(2)
            .replace("$", "")
            .split(".");
        let dollars = amt[0];
        let cents =
            amt.length > 1 && amt[1].length > 0 ? amt[1].substring(0, 2) : "00";
        if (cents.length === 1) {
            cents += "0";
        }
        return [sign, dollars, cents];
    }

    static addCommas(amount) {
        return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
}

export default MoneyService;